var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c(
      "div",
      {
        staticClass: "modal-mask",
        on: {
          click: function($event) {
            if ($event.target !== $event.currentTarget) {
              return null
            }
            return _vm.closeModal()
          }
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-wrapper",
            on: {
              click: function($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.closeModal()
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "modal-container", style: _vm.containerStyle },
              [
                _c(
                  "div",
                  { staticClass: "modal-header" },
                  [
                    _c("p", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.tituloModal))
                    ]),
                    _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        style: _vm.getColor,
                        attrs: { id: "btn", type: "text", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.triggerCloseModal()
                          }
                        },
                        nativeOn: {
                          mouseover: function($event) {
                            return _vm.hover($event)
                          },
                          mouseout: function($event) {
                            return _vm.leave($event)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "material-icons icon" }, [
                          _vm._v("close")
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "modal-body",
                    style: { padding: _vm.padding + "px" }
                  },
                  [
                    _vm.tipo === "trocaResponsavel"
                      ? _c(
                          "div",
                          [
                            _c("el-row", { staticClass: "processo" }, [
                              _c("p", [
                                _vm._v("Processo:"),
                                _c("b", [_vm._v("  Trocar responsável")])
                              ])
                            ]),
                            _c("el-row", { staticClass: "row" }, [
                              _c("p", [
                                _vm._v(
                                  "Selecione abaixo o nome do responsável a ser vinculado no processo:"
                                )
                              ])
                            ]),
                            _c(
                              "el-select",
                              {
                                staticClass: "full-width",
                                attrs: {
                                  placeholder: "Selecione o responsável",
                                  "no-match-text": "Usuário não encontrado",
                                  "no-data-text": "Nenhum usuário disponível",
                                  filterable: "filterable",
                                  clearable: "clearable"
                                },
                                model: {
                                  value: _vm.usuarioVinculado,
                                  callback: function($$v) {
                                    _vm.usuarioVinculado = $$v
                                  },
                                  expression: "usuarioVinculado"
                                }
                              },
                              _vm._l(_vm.usuariosDisponiveis, function(
                                usuario
                              ) {
                                return _c("el-option", {
                                  key: usuario.id,
                                  attrs: {
                                    label: usuario.pessoa.nomeRazaoSocial,
                                    value: usuario.id
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.tipo === "visualizarProcesso"
                      ? _c("div", [_c("h1", [_vm._v("Visualizar Processo")])])
                      : _vm._e()
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "modal-footer" },
                  [
                    _vm._t("footer", [
                      _vm.tipo === "trocaResponsavel"
                        ? _c(
                            "el-button",
                            { on: { click: _vm.trocarResponsavel } },
                            [_vm._v("Confirmar")]
                          )
                        : _vm._e()
                    ])
                  ],
                  2
                )
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a084b8f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a084b8f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppModalNova.vue
// module id = null
// module chunks = 